import { FC } from 'react';

import { IDiscoverProductsCarousel } from 'types';
import DiscoverProduct from '../../discoverProduct/DiscoverProduct';
import { DiscoverProductsCarouselSettings } from './discoverProductsCarouselSettings';
import DiscoverCarouselContainer from '../discoverCarouselContainer/DiscoverCarouselContainer';

const ProductsCarousel: FC<IDiscoverProductsCarousel> = ({
  listDetails,
  products,
  marginTop,
  titles,
  slidesToShow,
  onProductClick,
  onLikeClick,
  onListClick,
}) => {
  const settings = { ...DiscoverProductsCarouselSettings, slidesToShow };

  const onSeeAllClick = () => {
    if (listDetails) {
      onListClick(listDetails);
    }
  };

  return (
    <DiscoverCarouselContainer
      titles={titles}
      settings={settings}
      onSeeAllClick={onSeeAllClick}
      marginTop={marginTop}
    >
      {products.map((item) => (
        <DiscoverProduct
          item={item}
          onLikeClick={onLikeClick}
          onClick={onProductClick}
          key={item.id}
        />
      ))}
    </DiscoverCarouselContainer>
  );
};

export default ProductsCarousel;
